export default function CategoryDots({ categories }) {
  if (!categories || categories.length === 0) return null;

  const PRIORITY = ["vip", "email", "complain"];
  const COLORS = { vip: "#4CAF50", email: "#FF9800", complain: "#FFEB3B" };

  const dots = PRIORITY.filter((c) => categories.includes(c));
  if (dots.length === 0) return null;

  return (
    <div data-testid="category-dots" className="flex flex-col items-center gap-1">
      {dots.map((cat) => (
        <div
          key={cat}
          data-testid={`dot-${cat}`}
          className="rounded-full"
          style={{ width: 9, height: 9, backgroundColor: COLORS[cat] }}
        />
      ))}
    </div>
  );
}
